import { makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.palette.semantic["surface/base"],
    border: "1.5px solid transparent",
    borderRadius: 8,
    padding: "16px 12px",
    display: "flex",
    alignItems: "center",
    gap: 8,
    minHeight: 53,
    width: "100%",
    font: "inherit",
    fontSize: 14,
    textAlign: "left",
    color: theme.palette.text.primary,
    cursor: "pointer",
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
  checked: {
    backgroundColor: theme.palette.semantic["state/selected-bg"],
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  label: { flex: 1, overflowWrap: "anywhere" },
  check: { display: "block", flexShrink: 0 },
  circle: {
    borderRadius: "50%",
    width: 22,
    height: 22,
    boxSizing: "border-box",
    border: `1.5px solid ${theme.palette.semantic["border/strong"]}`,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& img": { display: "block" },
  },
  circleChecked: {
    borderColor: "transparent",
    backgroundColor: theme.palette.primary.main,
  },
}));

export const RegistrationChoice = React.forwardRef<
  HTMLButtonElement,
  {
    label: string;
    checked: boolean;
    list?: boolean;
    error?: boolean;
    onChange: () => void;
    onBlur?: () => void;
    checkedIcon?: React.ReactNode;
  }
>(({ label, checked, list, onChange, onBlur, error, checkedIcon }, ref) => {
  const classes = useStyles();
  return (
    <button
      type="button"
      ref={ref}
      role="checkbox"
      aria-checked={checked}
      aria-invalid={!!error}
      onClick={onChange}
      onBlur={onBlur}
      className={`${classes.root} ${checked ? classes.checked : ""}`}
    >
      {!list && checked &&
        (checkedIcon ?? <img src="/icons/ds-v2-step-check.svg" alt="" aria-hidden="true" className={classes.check} />)}
      <span className={classes.label}>{label}</span>
      {list && (
        <span className={`${classes.circle} ${checked ? classes.circleChecked : ""}`} aria-hidden="true">
          {checked && <img src="/icons/ds-v2-choice-check.svg" alt="" />}
        </span>
      )}
    </button>
  );
});

RegistrationChoice.displayName = "RegistrationChoice";
